import { CardHeader, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import CampaignIcon from '@mui/icons-material/Campaign'
import React, { useContext, useEffect, useState } from 'react'
import { useSnackbar } from 'notistack'
import { UserInfoContext } from '../../../contexts/UserInfoContext'
import CommentService from '../../../../services/commentService'
import momentUtil from '../../../../util/momentUtil'
import userService from '../../../../services/userService'
import { UserAvatar } from '../../../commonUIComponents/CustomAvatar'
import ReportPostModal from '../../ReportPostModal/ReportPostModal'

const CommentHeader = ({ authToken, comment, postId, onEditComment, submitOnSuccess }) => {
  const { id: commentId, userId, createdDate, avatarImageUrl } = comment
  const { userInfo } = useContext(UserInfoContext)
  const [commentUserNickname, setCommentUserNickname] = React.useState(null)
  const [openReportCommentModal, setOpenReportCommentModal] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const openMenuHandler = event => setAnchorEl(event.currentTarget)
  const closeMenuHandler = () => setAnchorEl(null)

  useEffect(() => {
    userService.getUserById(userId)
      .then(res => setCommentUserNickname(res.nickname))
      .catch(err => console.log(err))
  }, [])

  const editCommentHandler = () => {
    closeMenuHandler()
    onEditComment()
  }

  const deleteCommentHandler = () => {
    closeMenuHandler()
    CommentService.deleteCommentsById(postId, commentId)
      .then(submitOnSuccess)
      .then(res => {
        enqueueSnackbar('Successfully deleted the comment!.', { variant: 'success' })
      })
      .catch(err => {
        enqueueSnackbar(err.response.data.message, { variant: 'error' })
      })
  }

  const hideCommentHandler = () => {
    // will be added in the future
  }

  const reportCommentModalOpenHandler = () => {
    setOpenReportCommentModal(true)
  }

  const reportCommentModalCloseHandler = () => {
    setOpenReportCommentModal(false)
  }

  const reportCommentHandler = () => {
    closeMenuHandler()
  }

  return (
    <>
      {commentUserNickname
        ? (
          <CardHeader
            sx={{ padding: 0 }}
            avatar={
              <UserAvatar src={avatarImageUrl} nickname={commentUserNickname} />
            }
            title={commentUserNickname}
            subheader={momentUtil.createTimeDiffTag(createdDate)}
            action={
              <>
                {authToken && userInfo?.id === userId
                  ? (
                    <>
                      <Tooltip title="Option">
                        <IconButton
                          onClick={openMenuHandler}
                          sx={{ ml: 2 }}
                          aria-controls={open ? 'comment-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? 'true' : undefined}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        anchorEl={anchorEl}
                        id="comment-menu"
                        open={open}
                        onClose={openMenuHandler}
                        onClick={closeMenuHandler}
                        PaperProps={{
                          elevation: 0,
                          sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                              width: 32,
                              height: 32,
                              ml: -0.5,
                              mr: 1
                            },
                            '&::before': {
                              content: '""',
                              display: 'block',
                              position: 'absolute',
                              top: 0,
                              right: 14,
                              width: 10,
                              height: 10,
                              bgcolor: 'background.paper',
                              transform: 'translateY(-50%) rotate(45deg)',
                              zIndex: 0
                            }
                          }
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                      >
                        <MenuItem onClick={editCommentHandler}>
                          <ListItemIcon>
                            <EditIcon fontSize="small" />
                          </ListItemIcon>
                          Edit
                        </MenuItem>
                        <MenuItem onClick={deleteCommentHandler}>
                          <ListItemIcon>
                            <DeleteIcon fontSize="small" />
                          </ListItemIcon>
                          Delete
                        </MenuItem>
                      </Menu>
                    </>
                    )
                  : (
                    <>
                      <Tooltip title="Option">
                        <IconButton
                          onClick={openMenuHandler}
                          sx={{ ml: 2 }}
                          aria-controls={open ? 'comment-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? 'true' : undefined}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        anchorEl={anchorEl}
                        id="comment-menu"
                        open={open}
                        onClose={openMenuHandler}
                        onClick={closeMenuHandler}
                        PaperProps={{
                          elevation: 0,
                          sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                              width: 32,
                              height: 32,
                              ml: -0.5,
                              mr: 1
                            },
                            '&::before': {
                              content: '""',
                              display: 'block',
                              position: 'absolute',
                              top: 0,
                              right: 14,
                              width: 10,
                              height: 10,
                              bgcolor: 'background.paper',
                              transform: 'translateY(-50%) rotate(45deg)',
                              zIndex: 0
                            }
                          }
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                      >
                        <MenuItem onClick={hideCommentHandler}>
                          <ListItemIcon>
                            <VisibilityOffIcon fontSize="small" />
                          </ListItemIcon>
                          Hide
                        </MenuItem>
                        <MenuItem onClick={reportCommentModalOpenHandler}>
                          <ListItemIcon>
                            <CampaignIcon fontSize="small" />
                          </ListItemIcon>
                          Report
                        </MenuItem>
                      </Menu>
                    </>
                    )
                }
              </>
            }
          />
          )
        : (
          <></>
          )
      }
      <ReportPostModal post={null} comment={comment} open={openReportCommentModal} setOpenReportPostModal={setOpenReportCommentModal} onClose={reportCommentModalCloseHandler} submitOnSuccess={reportCommentHandler} />
    </>
  )
}

export default CommentHeader
